export const ColorPicker = {
    orangeDark: '#ff7e00',
    orangeLight: '#ffe5cc',
    purpleDark: '#9866CA',
    purpleLight: '#ECEDFF',
    yellowDark: '#aa8d00',
    yellowLight: '#fef2cc',
    tealDark: '#00a993',
    tealLight: '#ecedff',
    blueLight: '#00A8CD',
    toscaLight: '#DDFFFB',
    toscaDark: '#00A993'
};